// ==================== SERVICIO DE EQUIPO ====================
// Maneja todas las operaciones CRUD de miembros del equipo

import api from './api';
import authService from './authService';

const equipoService = {
  // ==================== OBTENER TODOS LOS MIEMBROS ====================
  async obtenerMiembros(soloActivos = true) {
    try {
      const response = await api.get('/equipo', {
        params: { activo: soloActivos },
      });
      
      return response.data.miembros || [];
    } catch (error) {
      console.error('Error al obtener miembros:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener miembros' };
    }
  },

  // ==================== OBTENER UN MIEMBRO ====================
  async obtenerMiembro(idMiembro) {
    try {
      const response = await api.get(`/equipo/${idMiembro}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener miembro:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener miembro' };
    }
  },

  // ==================== AGREGAR MIEMBRO ====================
  async agregarMiembro(datosMiembro) {
    try {
      const response = await api.post('/equipo', datosMiembro);
      
      return response.data.miembro;
    } catch (error) {
      console.error('Error al agregar miembro:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al agregar miembro' };
    }
  },

  // ==================== AGREGAR MIEMBRO EN PROYECTO ESPECÍFICO ====================
  async agregarMiembroEnProyecto(datosMiembro, proyectoId) {
    try {
      const response = await api.post('/equipo', datosMiembro, {
        headers: { 'X-Proyecto-Id': proyectoId }
      });
      return response.data.miembro;
    } catch (error) {
      console.error('Error al agregar miembro:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al agregar miembro' };
    }
  },

  // ==================== ACTUALIZAR MIEMBRO ====================
  async actualizarMiembro(idMiembro, datosActualizados) {
    try {
      const response = await api.put(`/equipo/${idMiembro}`, datosActualizados);
      return response.data.miembro;
    } catch (error) {
      console.error('Error al actualizar miembro:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al actualizar miembro' };
    }
  },

  // ==================== ACTUALIZAR MIEMBRO EN PROYECTO ESPECÍFICO ====================
  // Usado desde la vista global, donde el miembro puede pertenecer a un proyecto
  // distinto al proyecto activo del selector — hay que forzar el X-Proyecto-Id.
  async actualizarMiembroEnProyecto(idMiembro, datosActualizados, proyectoId) {
    try {
      const response = await api.put(`/equipo/${idMiembro}`, datosActualizados, {
        headers: { 'X-Proyecto-Id': proyectoId }
      });
      return response.data.miembro;
    } catch (error) {
      console.error('Error al actualizar miembro:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al actualizar miembro' };
    }
  },

  // ==================== ELIMINAR MIEMBRO ====================
  async eliminarMiembro(idMiembro) {
    try {
      const response = await api.delete(`/equipo/${idMiembro}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar miembro:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al eliminar miembro' };
    }
  },

  // ==================== ELIMINAR MIEMBRO EN PROYECTO ESPECÍFICO ====================
  // Usado desde la vista global, donde el miembro puede pertenecer a un proyecto
  // distinto al proyecto activo del selector — hay que forzar el X-Proyecto-Id.
  async eliminarMiembroEnProyecto(idMiembro, proyectoId) {
    try {
      const response = await api.delete(`/equipo/${idMiembro}`, {
        headers: { 'X-Proyecto-Id': proyectoId }
      });
      return response.data;
    } catch (error) {
      console.error('Error al eliminar miembro:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al eliminar miembro' };
    }
  },

  // ==================== OBTENER MIEMBROS PARA NOTIFICACIONES ====================
  async obtenerMiembrosParaNotificaciones(tipo = 'email') {
    try {
      const proyectoId = authService.obtenerProyectoId();
      
      if (!proyectoId) {
        throw new Error('No hay proyecto seleccionado');
      }
      
      const response = await api.get(`/equipo/notificaciones/${proyectoId}`, {
        params: { tipo },
      });
      
      return response.data.miembros || [];
    } catch (error) {
      console.error('Error al obtener miembros para notificaciones:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener miembros' };
    }
  },

  // ==================== MARCAR NOTIFICACIÓN ENVIADA ====================
  async marcarNotificacionEnviada(idMiembro) {
    try {
      const response = await api.put(`/equipo/${idMiembro}/notificacion`);
      return response.data;
    } catch (error) {
      console.error('Error al marcar notificación:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al marcar notificación' };
    }
  },
};

export default equipoService;
